import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { FormSurface, useFormPalette } from "../forms/DynamicFormPrimitives";
import { formatMessageTime } from "./conversationUtils";

function parseEvent(content) {
  if (!content) return null;
  if (typeof content === "object") return content;
  try {
    return JSON.parse(content);
  } catch {
    return null;
  }
}

export default function ArtifactEventMessage({ content, timestamp }) {
  const palette = useFormPalette();
  const parsed = useMemo(() => parseEvent(content), [content]);
  const title = parsed?.title || "Artifact";
  const eventName = parsed?.eventName || "event";
  const payload = parsed?.payload && typeof parsed.payload === "object" ? parsed.payload : {};
  const payloadText = JSON.stringify(payload, null, 2);

  return (
    <Box sx={{ px: 2.5, py: 0.4 }}>
      <FormSurface
        title={`Artifact "${title}" emitted "${eventName}"`}
        subtitle={timestamp ? formatMessageTime(timestamp) : undefined}
      >
        <Typography sx={{ fontSize: "11px", fontWeight: 600, color: palette.textSecondary, mb: 0.5 }}>
          Payload
        </Typography>
        <Typography
          component="pre"
          sx={{
            m: 0,
            fontSize: "12px",
            fontFamily: "monospace",
            color: palette.textPrimary,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {payloadText}
        </Typography>
      </FormSurface>
    </Box>
  );
}
